/* istanbul ignore file */
export { default } from './IconFeatureCardBlock';
